var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgReverseString = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    d: "M7.234 12.555v1.695h-.807V9.912H7.75q.444 0 .76.093.317.09.518.255a1 1 0 0 1 .297.396q.096.228.096.504a1.3 1.3 0 0 1-.252.768q-.12.159-.3.279-.177.12-.405.192a.8.8 0 0 1 .264.249l1.086 1.602h-.726a.36.36 0 0 1-.18-.042.4.4 0 0 1-.123-.12l-.912-1.389a.3.3 0 0 0-.114-.111.4.4 0 0 0-.18-.033zm0-.579h.504q.228 0 .396-.057a.8.8 0 0 0 .28-.156.64.64 0 0 0 .164-.24.8.8 0 0 0 .054-.303q0-.33-.219-.507-.216-.177-.663-.177h-.516zm5.834-2.064v.642h-1.923v1.203h1.515v.621h-1.515v1.227h1.923v.645h-2.736V9.912zm.272 0h.65a.27.27 0 0 1 .27.183l1.02 2.646a5 5 0 0 1 .186.609q.07-.345.172-.609l1.017-2.646a.3.3 0 0 1 .096-.126.26.26 0 0 1 .17-.057h.652L15.82 14.25h-.73z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgReverseString);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/reverse-string.a1cc660f.svg";